import React, { Component } from 'react';
import { Accordion, Menu } from 'semantic-ui-react';
import SubLink from './sublink';
import { ASIDEDROPDOWN_CONSTANTS, FEATURES } from '../../config/features';

const Masters = (
    <div className="p-0 m-0">
        <SubLink subLink="Expense" To="/expense" />
        <SubLink subLink="Partner" To="/partner" />
        <SubLink subLink="Branch" To="/branch" />
        {/* <SubLink subLink="Product" To="/product" /> */}
    </div>
)

const Reports = (
    <div className="p-0 m-0">
        { FEATURES.isInternalFreightMISReportEnabled ?
          <>
            <SubLink subLink={ASIDEDROPDOWN_CONSTANTS.reports.INTERNAL_FREIGHT_MIS_REPORT} To="/reportsheet?INTERNAL_FREIGHT_MIS_REPORT" type="INTERNAL_FREIGHT_MIS_REPORT" />
          </>
          : null
        }
    </div>
)


export default class AsideDropdown extends Component {
    state = { activeIndex: 0 };

    handleClick = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;
        const newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex })
    };

    render() {
        const { activeIndex } = this.state;

        return (
            <>
            <Accordion as={Menu} vertical style={{ backgroundColor: '#2D373C', width: "100%" }}>
                <Menu.Item className="mb-3 accordionStyle">
                    <Accordion.Title
                        className="w3-text-white w3-small"
                        active={activeIndex === 1}
                        content={<div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                            <img className='ml-2' src="assets/svg/master.svg" alt="Masters" width="18" />
                            <span className="labelName">&nbsp;&nbsp;&nbsp;&nbsp;Masters</span>
                        </div>}
                        index={1}
                        onClick={this.handleClick}
                    />
                    <Accordion.Content active={activeIndex === 1} content={Masters} />
                </Menu.Item>
            </Accordion>

            <Accordion as={Menu} vertical style={{ backgroundColor: '#2D373C', width: "100%" }}>
                <Menu.Item className="mb-3 accordionStyle">
                    <Accordion.Title
                        className="w3-text-white w3-small"
                        active={activeIndex === 2}
                        content={<div className="nav-link p-hover p-3 w3-text-white checklink stylefont">
                            <img className='ml-2' src="assets/svg/report.svg" alt="Reports" width="18" />
                            <span className="labelName">&nbsp;&nbsp;&nbsp;&nbsp;Reports</span>
                        </div>}
                        index={2}
                        onClick={this.handleClick}
                    />
                    <Accordion.Content active={activeIndex === 2} content={Reports} />
                </Menu.Item>
            </Accordion>
            </>
        )
    }
}